import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import { CallIcon, ExclamationIcon, MessageIcon, NoParkingIcon, PetIcon, TowingIcon, VehicleLightsOn, VehicleWindowIcon } from "../../../Assets/images/svgs";
import { useNavigate, useSearchParams } from "react-router-dom";
import { notifyUser } from "../../../APIs";
import { useToast } from "@chakra-ui/react";
import PATHS from "../../../Routes/paths";

const SecuredCallRsn = () => {
  const RESONS_TO_LIST = [
    { idx: 1, txt: "Vehicle is wrongly parked", icon: <NoParkingIcon /> },
    { idx: 2, txt: "The lights of the vehicle is on", icon: <VehicleLightsOn /> },
    { idx: 3, txt: "The vehicle is getting towed", icon: <TowingIcon /> },
    { idx: 4, txt: "There is a baby or pet in vehicle", icon: <PetIcon /> },
    { idx: 5, txt: "The window of vehicle is open", icon: <VehicleWindowIcon /> },
    { idx: 6, txt: "Other reason", icon: <ExclamationIcon />, expand: true },
  ]

  const CONTACT_TYPE = [
    { type: 1, displayText: "Call Now", icon: <CallIcon className="call-messgae-icon" />, nm: "Call" },
    { type: 2, displayText: "Send Message Now", icon: <MessageIcon className="call-messgae-icon" />, nm: "Message" },
  ]

  const CONTACT_VIA_CALL = 1;
  const CONTACT_VIA_MESSAGE = 2;

  const [ searchParams ] = useSearchParams();
  const [ btnType, setBtnType ] = useState(1);
  const [ btnTypeToShow, setBtnTypeToShow ] = useState(1);
  const [ selectedRsn, setSelectedRsn ] = useState(0);
  const [ otherRsn, setOtherRsn ] = useState("");
  const [ errorMsg, setErrorMsg ] = useState("");
  const [ expandSelected, setExpandSelected ] = useState(false);
  const [ userData, setUserData ] = useState({});
  const [ saveBtnDisabled, setSaveBtnDisabled ] = useState(true);
  const navigate = useNavigate();
  const Toast = useToast();

  useEffect(() => {
    document.body.classList.remove("Ev-Light-Theme-Container");
    let type = searchParams.get("type");
    try {
      type = JSON.parse(type);
    } catch (e) {
      type = 1
    }

    setBtnType(type);
    let btnToShow = CONTACT_TYPE.find(contact => contact.type === type);
    if (btnToShow && btnToShow.type) setBtnTypeToShow(btnToShow);
    else setBtnTypeToShow(CONTACT_TYPE[0]);

    if (window.data) setUserData(window.data);
  }, []);

  const handleIvrCall = () => {
    navigate(`/${PATHS.CONTACT_STICKER}/${PATHS.CALL_OWNER}`, { state: { stickerId: searchParams.get("sid"), contactType: 2, rsn: selectedRsn.idx, custRsn: selectedRsn.txt } });
  }

  const handleNotification = () => {
    let payload = { uid: userData.uid, vid: searchParams.get("vid"), stickerId: searchParams.get("sid"), notifType: 3, contactRsn: selectedRsn.idx, custMsg: selectedRsn.txt };
    if (selectedRsn.idx === 6) payload.custMsg = otherRsn;
    setSaveBtnDisabled(true);
    notifyUser(payload, (err) => {
      setSaveBtnDisabled(false);
      if (err) Toast({ isClosable: true, description: "Unable to send message at the moment. Please try again later", position: "bottom", variant: "subtle", duration: 3000 });
      else {
        Toast({ status: "success", isClosable: true, description: "Notification sent successfully", position: "bottom", variant: "subtle", duration: 3000 });
        setTimeout(() => {
          navigate(`${PATHS.SCANNED_PREVIEW_PAGE}?uc=${searchParams.get("sid")}`);
        }, 1000);
      }
    });
  }

  const handleCallOrText = () => {
    if (!selectedRsn) return setErrorMsg("Please type or select a reason for call");
    if (expandSelected && !otherRsn) return setErrorMsg("Please type or select a reason for call");
    if (saveBtnDisabled) return;

    if (btnType === CONTACT_VIA_CALL) handleIvrCall();
    else if (btnType === CONTACT_VIA_MESSAGE) handleNotification();
  }

  const handleReasonSelect = (checked, reason) => {
    setSelectedRsn(checked ? reason : 0);
    setErrorMsg("");

    setSaveBtnDisabled(false);
    setExpandSelected(!!(reason.expand && checked));
  }

  return (
    <div className="secured-call-rsn">
      <p className="secured-call-rsn-heading">Please select a reason of contacting vehicle owner</p>

      <div className="reason-selection-list">
        {RESONS_TO_LIST.map(reason => (
          <div className="gradient-border-box">
            <label className={`reason-box ${reason.expand && expandSelected ? "expanded-box" : ""}`}>
              <div className="icon-text-container">
                <input onChange={(e) => handleReasonSelect(e.target.checked, reason)} type="radio" name="reason-list" className="reason-input" />
                {reason.icon || null}
                <p className="reason-text">{reason.txt || null}</p>
              </div>
              {reason.expand && expandSelected ? <textarea value={otherRsn} className="other-reason-input" placeholder="Type your reason here..." onChange={(e) => {setOtherRsn(e.target.value); setErrorMsg("");}}></textarea> : null}
            </label>
          </div>
        ))}
      </div>

      {errorMsg ? <p className="call-rsn-err-msg">{errorMsg || ""}</p> : null}
      <button onClick={handleCallOrText} className={`call-or-text-btn cs-btn-gradient ${saveBtnDisabled ? "save-btn-disabled" : ""}`}>
        { btnTypeToShow.icon }
        { btnTypeToShow.displayText }
      </button>
    </div>
  )
}

export default SecuredCallRsn
